module.exports = __webpack_public_path__ + "static/media/feature-banner-hostel.ff506670.jpg";